import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=23543608"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23543608')) {
      api.createRecord('23543608', component.options)
    } else {
      api.reload('23543608', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=23543608", function () {
      api.rerender('23543608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Index.vue"
export default component.exports